import React, { useEffect } from "react";
import classes from "./Modal.module.css";
import ErrorMessage from "../components/ErrorMessage";
import closeIcon from "../assets/close_icon.png";
import useLanguage from "../utils/useLanguage";
import { useTranslation } from "react-i18next";
export default function Modal({
  open,
  onClose,
  title,
  subHeaderChildren,
  children,
  error,
  beforeFooterChildren,
  withDropdown = false,
  footer,
  modalSize,
}) {
  const { currentDirection } = useLanguage();
  const { t } = useTranslation("general");

  useEffect(() => {
    // Add the 'no-scroll' class to the body when the modal is open
    document.body.classList.add("no-scroll");

    // Remove the 'no-scroll' class from the body when the modal is closed
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, []);

  return (
    <div className={classes.modalOverlay} onClick={onClose}>
      <div
        className={`${classes.modalContainer} ${
          modalSize ? modalSize : ""
        } c-modal`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={classes.modal}>
          <section
            className={
              "u-padding_500 o-row o-row--horizontal-align_space-between"
            }
          >
            <h2 className={classes.modalTitle}>{t(title)}</h2>
            <button
              id="modal-close-button"
              className={classes.modalCloseIcon}
              onClick={onClose}
            >
              <img
                src={closeIcon}
                alt="close modal"
                className={classes.closeIcon}
                style={
                  currentDirection === "rtl"
                    ? { left: "20px" }
                    : { right: "20px" }
                }
              />
            </button>
          </section>

          {subHeaderChildren && (
            <section className={classes.modalSubHeader}>
              {subHeaderChildren}
            </section>
          )}

          {/* MODAL BODY */}
          <section
            className={`${
              classes.modalBody
            }  u-padding--left_500 u-padding--right_500 u-padding--bottom_500 u-styled-scrollbar ${
              withDropdown ? classes.withDropdown : ""
            }`}
          >
            {children}
          </section>

          {beforeFooterChildren && (
            <section className={classes.beforeFooterChildren}>
              {beforeFooterChildren}
            </section>
          )}

          {error && (
            <ErrorMessage classList="o-row o-row--horizontal-align_center u-padding--bottom_300">
              {error}
            </ErrorMessage>
          )}
          <section className={"u-padding_500"}>{footer}</section>
        </div>
      </div>
    </div>
  );
}
